import React from 'react';
import { OperatorMenu } from '../OperatorMenu/OperatorMenu';
import styles from './headerTitleBar.module.scss';

type Props = {
	id?: string;
	icon?: React.ReactNode;
	title: string;
	isSticky?: boolean;
	helpButton?: React.ReactNode;
};

const HeaderTitleBar: React.FC<Props> = ({ id, icon, title, helpButton }) => {
	return (
		<div id={id} className={styles.headerBar}>
			<div className={styles.titleSection}>
				<div className={styles.icon}>{icon}</div>
				<h6 className={styles.headerTitle}>{title}</h6>
			</div>
			<div className={styles.operatorSection}>
				{helpButton && helpButton}
				<OperatorMenu />
			</div>
		</div>
	);
};

export { HeaderTitleBar };
